module.exports = __webpack_public_path__ + "static/media/403-forbidden.4f8b3c18.png";